import React, { useState } from 'react';
import { Popover, List, ListItem, ListItemButton, ListItemText, Box } from '@mui/material';
import { CiPhone } from 'react-icons/ci';

export default function ContactPhone({ mobileNumber }) {
  const [anchorEl, setAnchorEl] = useState(null);

  // Split string by commas, remove spaces, remove empty items
  const phoneNumbers = mobileNumber
    ? mobileNumber.split(',').map(num => num.trim()).filter(Boolean)
    : [];

  // If there are no numbers, render nothing
  if (phoneNumbers.length === 0) return null;

  const hasMultiple = phoneNumbers.length > 1;

  const handleIconClick = (event) => {
    event.stopPropagation(); 
    if (hasMultiple) {
      setAnchorEl(event.currentTarget);
    }
    event.stopPropagation(); 
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box className="icons-container" display="inline-block">
      {hasMultiple ? (
        <>
          <span 
            onClick={(e) => {e.stopPropagation(); handleIconClick(e); e.stopPropagation();}} 
            className='location-button'
            // style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
          >
            <CiPhone  />
          </span>
          
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={(e)=>{e.stopPropagation();handleClose();}}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <List dense sx={{ p: 0 }}>
              {phoneNumbers.map((number, index) => (
                <ListItem disablePadding key={index}>
                  <ListItemButton 
                    component="a" 
                    href={`tel:${number}`}
                    onClick={(e)=>{e.stopPropagation();handleClose();}}
                  >
                    <ListItemText primary={number} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Popover>
        </>
      ) : (
        <div className='location-button'  onClick={(e) => {e.stopPropagation();}}>
            <a href={`tel:${phoneNumbers[0]}`} >
            <CiPhone  /> 
        </a>
        </div>
        
      )}
    </Box>
  );
}
